module.exports = __webpack_public_path__ + "img/logo-blocks.a1b0fd37.svg";